import { ScanQrCouponReaderComponent } from "./scan-qr-coupon-reader/scan-qr-coupon-reader.component";
import { ScanQrCouponResultPage } from "./scan-qr-coupon-result/scan-qr-coupon-result.page";

export const COMPONENTS = [
  ScanQrCouponReaderComponent,
  ScanQrCouponResultPage
];
